import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Stepper from "./stepper"
import moment from "moment"
import Spinner from "../spinner"
import { ToastContainer, toast } from 'react-toastify'
import saveLead from "../../Config/GlobalFunctions"
import { useNavigate } from 'react-router-dom';
import configData from "../../config.json"

function Terms() {
  const [loading, setLoading] = useState(false)
  const [continueStep, setContinueStep] = useState(false)
  const [isCheckedTC, setIsCheckedTC] = useState(false)
  const [isCheckedCon, setIsCheckedCon] = useState(false)
  const navigate = useNavigate()

  const handleCheckTC = (event) => {

    setIsCheckedTC(event.target.checked)
    setLoading(true)

    if (!isCheckedTC) {
      setContinueStep(true)
      localStorage.setItem('dateTC', moment().format())
    } else {
      setContinueStep(false)
      localStorage.removeItem('dateTC')
    }
    setTimeout(function () {
      setLoading(false)
    }, 2500)
  }

  const handleCheckCon = (event) => {
    setLoading(true)
    setIsCheckedCon(event.target.checked)
    if (!isCheckedCon) {
      localStorage.setItem('dateCon', moment().format())
    } else {
      localStorage.removeItem('dateCon')
    }
    setTimeout(function () {
      setLoading(false)
    }, 2500)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const data = JSON.parse(sessionStorage.getItem('lead'))
    data.FECHA_INGRESO = localStorage.getItem('dateTC')
    data.ETAPA = 'Aceptación de términos y condiciones'
    sessionStorage.setItem('lead', JSON.stringify(data))
    saveLead()

    data.ETAPA = 'Consentimiento informado'
    data.ACEPTA_CC = localStorage.getItem("dateCon") !== null ? 'S' : 'N'
    data.FECHA_INGRESO = localStorage.getItem("dateCon") !== null ? localStorage.getItem("dateCon") : ''
    sessionStorage.setItem('lead', JSON.stringify(data))
    saveLead()
    navigate('/information/career', { replace: true });
  }

  return (
    <div>
      <Spinner show={loading}></Spinner>
      <Stepper step="2"></Stepper>
      <section className="text-center container-fluid">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <ToastContainer />

        <div className="row">
          <div className="offset-lg-4 col-lg-4 mt-5 mb-4 col-sm-12">
            <div className="col-12">
              <div className="form-check" style={{ textAlign: 'left' }}>
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" onClick={handleCheckTC} />
                <label className="form-check-label" for="flexCheckDefault">
                  Acepto de manera expresa e incondicional los términos y condiciones.<br></br>
                  <a href={configData.INFO_LINKS.TERMINOS_CONDICIONES} target="_blank">Términos y condiciones</a>
                </label>
              </div>
            </div>
            <div className="col-12 mt-2">
              <div className="form-check" style={{ textAlign: 'left' }}>
                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" onClick={handleCheckCon} />
                <label className="form-check-label" for="flexCheckChecked">
                  Acepto el consentimiento informado.<br></br>
                  <a href={configData.INFO_LINKS.CC} target="_blank">Términos</a>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-2 pb-5 pt-5">
          <div className="pt-2 offset-lg-3 col-lg-3 offset-sm-1 col-sm-10 text-center">
            <Link className="btn btn-lg w-100 btn-red" to="/information/complete">Regresar</Link>
          </div>
          <div className="pt-2 col-lg-3 col-sm-10 text-center">
            <Link className={`btn btn-lg w-100 btn-yellow ${!continueStep ? "disabled" : ""}`} disabled={continueStep} onClick={handleSubmit}>Continuar</Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Terms